<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- Administrators -->
        <div class="administrator-box">
          <div class="sett-head">
            <h1>Admin rights for {{ company_name }} </h1>
            <p>Here you can define which employees have admin permissions. This includes setting up schedules, deleting users and exchanging shifts between other employees.</p>
          </div>
          <div class="info-adm">
            <div class="info-adm-head">
              <div class="head-left"></div>
              <span class="acc-own">Account Owner</span>
              <span class="acc-own">Administrator</span>
            </div>
            <div class="info-adm-body">
              <div class="adm-prof">
                <div class="avtar">
<!--                  <img src="https://stagingapipavagt.6lgx.com/storage/thumbnails/WJ3uqtYJYrCTtuPglpmRnZHdkq6vhKxusuXklO0j.jpg" alt="">-->
                  <img :src="$API_URL+'storage/'+user.image"
                       alt="Profile image"
                       width="80"
                       height="80"
                       v-if="user.image !== ''"
                  />
                  <span v-if="user.image === ''" class="profile-name text-capitalize">
<!--                     {{ user.name && isNaN(user.name) ? String(user.name).slice(0)+String(user.name.split(' ')[1]).slice(0,1): '' }}-->
                    {{ (user.name)&& isNaN(user.name) ? String(user.name).slice(0,1)+String(user.name.split(' ')[1]).slice(0,1): '' }}
                  </span>
                </div>
                <div class="descrip">
                  <span class="name text-capitalize">{{ user.name }}</span>
                </div>
              </div>
              <div class="check">
                <input type="checkbox" disabled checked>
              </div>
              <div class="check">
                <input type="checkbox" checked>
              </div>
            </div>
          </div>

          <div class="info-adm" v-for="administrator in administrators">
            <div class="info-adm-body">
              <div class="adm-prof">
                <div class="avtar">
                  <img :src="$API_URL+'storage/'+administrator.user.image"
                       alt="Profile image"
                       width="80"
                       height="80"
                       v-if="administrator.user.image !== ''"
                  />
                  <span v-if="administrator.user.image === ''" class="profile-name text-capitalize">
                    <!-- {{ administrator.user.name && isNaN(administrator.user.name) ? String(administrator.user.name).slice(0,1)+String(administrator.user.name.split(' ')[1]).slice(0,1): '' }} -->
                    {{ administrator.user.name && isNaN(administrator.user.name) ? administrator.user.name.split(' ').slice(0, 2).map(part => part[0].toUpperCase()).join('') : administrator.user.name ? administrator.user.name[0].toUpperCase() : '' }}
                  </span>
                </div>
                <div class="descrip">
                  <span class="name text-capitalize"> <router-link :to="'/employee/profile/'+administrator.user.uuid"> {{ administrator.user.name }} </router-link></span>
                  <div><span v-for="role in administrator.user.employeeJobType" class="text-capitalize" > <i class="ico ico-fill-circle"  :style="'color:'+role.get_job_roles.color"></i>{{ role.get_job_roles.name }}</span></div>
                </div>
              </div>
              <div class="check">
              </div>
              <div class="check">
                <input type="checkbox" @change="removeAdministrator(administrator.id,'true')" checked :id="'customCheck'+administrator.id">
              </div>
            </div>
          </div>


          <div class="info-adm">
            <div class="info-adm-body">
              <div class="adm-prof">
                <div class="avtar">
<!--                    <img src="https://stagingapipavagt.6lgx.com/storage/thumbnails/WJ3uqtYJYrCTtuPglpmRnZHdkq6vhKxusuXklO0j.jpg" style="background: black" alt="">-->
                  <span class="profile-name text-uppercase">
                  </span>
                </div>
                <div class="descrip flex-grow-1">
                  <a href="javascript:void(0);" class="name text-capitalize" v-show="isMakeAdmin===false" @click="addAdministratorBtn">Add administrator</a>
                  <div class="input-group" v-show="isMakeAdmin">
                    <select name="" v-model="form.user_id" class="form-control text-capitalize" id="">
                      <option value="">Choose a user</option>
                      <option class="text-capitalize" v-for="employee in employees" :value="employee.id">{{employee.name}} ({{employee.employeeJobType[0].get_job_roles.name}}) </option>
                    </select>
                    <div class="input-group-append">
                      <button @click="makeAdministratorPost" class="btn btn-secondary" type="button">Make admin</button>
                      <button @click="cancelAdministratorBtn" class="btn btn-outline-secondary " type="button">Cancel</button>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import sidebar from "./sidebar";
import Swal from "sweetalert2";
export default {
  components:{
    sidebar,Swal
  },
  props: [],
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      company_name: this.$store.getters.getSelectedCompany.name,
      user: this.$store.getters.getUser,
      isMakeAdmin:false,
      employees:[],
      administrators:[],
      employeeIds:[],
      form:{
        user_id:''
      },
    }
  },
  serverPrefetch() {
  },
  created() {
    this.getCompanyEmployee();
    this.getCompanyAdministrator();
  },
  mounted() {
  },
  methods: {
    addAdministratorBtn(){
      this.isMakeAdmin=true;
    },
    cancelAdministratorBtn(){
      this.isMakeAdmin=false;
    },
    getCompanyEmployee(){
      let params = {
        employeeIds: this.$store.getters.getUser.id,
        company_id: this.company_id,
      };
      this.$axios.get(this.$GetEmployeesWithOutSelect, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.employees = response.data.result;
      });
    },
    makeAdministratorPost(){
      axios.post(this.$MakeAdministrator,
        {
          user_id: this.form.user_id,
          company_id: this.company_id,
          role_name: 'admin',
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.isMakeAdmin=false;
            this.getCompanyAdministrator();
          }
        });
    },
    removeAdministrator(id,valueType){
      // if (confirm("Do you really want to remove?")) {
      new Swal({
        title: "Warning",
        icon: "info",
        text: 'Do you really want to remove?',
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes"
      }).then((result) => {
        if (result.value) {
          axios.post(this.$RemoveAdministrator,
            {
              id: id,
              company_id: this.company_id,

            }, {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.status == 200) {
                this.getCompanyAdministrator();
              }
            });
        }else{
          if(valueType===true){
            $("#customCheck"+id).prop("checked", false);
          }else{
            $("#customCheck"+id).prop("checked", true);
          }
        }
      })


    },
    getCompanyAdministrator(){
      let params = {
        company_id: this.company_id,
      };
      this.$axios.get(this.$GetCompanyAdministrator, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.administrators = response.data.result;
      });
    },
  }
}
</script>
